import { discordInviteURL } from '../config'
import PageContainer from '../components/PageContainer'
import MetaDesc from '../components/MetaDesc'
import NewTabLink from '../components/NewTabLink'

const Faq = () => {
  return (
    <PageContainer>
      <MetaDesc>
        Frequently asked questions about how to play Mastermine.
      </MetaDesc>

      <h2>Frequently asked questions</h2>

      <h3>Questions about the Steam release?</h3>

      <p>
        Visit the <NewTabLink href='/steam-faq'>Steam migration FAQ</NewTabLink>
      </p>

      <h3>How do I play?</h3>

      <p>
        Mastermine plays very similarly to minesweeper. If you're
        still wondering how to play after playing the tutorial, try
        online guides for regular minesweeper, as the skills are very transferrable.
      </p>

      <p>
        Still having trouble? The other players in our <NewTabLink href={discordInviteURL}>Discord community</NewTabLink> will be happy to help.
      </p>

      <h3>Does the game feature Chording?</h3>

      <p>
        <a href='http://www.minesweeper.info/wiki/Chord'>Chording</a>, an
        advanced minesweeper technique is present in the game. Head to Settings -&gt;
        Controls and bind it to an action to enable it.
      </p>

      <h3>I can't press the "Manage Data Privacy" button</h3>

      <p>
        This button sometimes doesn't work on devices with an AdBlocker enabled,
        disable it and try again.
      </p>

      <h3>Is there a leaderboard API?</h3>

      <p>
        Yes! If you'd like to pull leaderboard data for your own purposes, such
        as creating graphs or tracking world records, hit either of the following
        URLs:
      </p>

      <p>
        <b>/api/top100?cubeSize=5</b> - Will give you the top 100 players for
        that cube size (5 in this example), as well as the number of players on
        that board, in JSON.
      </p>

      <p>
        <b>/api/sizes</b> - Will give you a list of cube sizes that have at least
        1 record alongisde who holds the WR for that size, in JSON.
      </p>

      <p>
        Notes: Both endpoints are cached, you might not see positions update for
        as much as 10 minutes after they update in-game. No data is given out
        that is not visible in-game. Profane nicknames are censored.
      </p>
    </PageContainer>
  )
}

export default Faq
